function u(e, r) {
  if (!Number.isInteger(e) || e < 0) throw new Error("n must be a non-negative integer.");
  var n = 0;
  return function () {
    if (++n >= e) return r.apply(void 0, arguments);
  };
}
export { u as after };